import React from "react";

/**
 * Custom hook to keep state and ref in sync
 * Useful when you need both reactive state for UI updates
 * and ref access for synchronous operations (cleanup, event handlers)
 */
export function useStateWithRef<T>(initialValue: T) {
  const [state, setState] = React.useState(initialValue);
  const stateRef = React.useRef(state);

  const setStateAndRef = React.useCallback((value: T | ((prev: T) => T)) => {
    setState((prev) => {
      const newValue = typeof value === "function" ? (value as (prev: T) => T)(prev) : value;
      stateRef.current = newValue;
      return newValue;
    });
  }, []);

  return [state, setStateAndRef, stateRef] as const;
}
